import React, {useMemo} from 'react';
import { SortableContainer, SortableElement, SortableHandle, arrayMove } from 'react-sortable-hoc';
import { IconButton } from '@material-ui/core';
import { DragHandle as DragHandleIcon } from '@material-ui/icons';
import styled from "styled-components";

const DragHandle = SortableHandle(() => {
    return (
        <span>
            <IconStyled>
                <DragHandleIcon/>
            </IconStyled>
        </span>)
});

const SortableItem = SortableElement(({ item, itemComponent: ItemComponent, ...props }) => (
    /**
     * PRECAUTION!
     * index can't be passed to the component,
     * because it will be overriden by SortableElement.
     */
    <DivStyled
    >
        <ItemComponent item={item.value} idx={item.id} DragHandle={DragHandle} {...props} />
    </DivStyled>
));

const SortableList = SortableContainer(({ items, itemComponent, ...props }) => (
    <div>
        {items.map((item, index) => (
            <SortableItem
                key={`item-${item.id}`}
                index={index}
                item={item}
                itemComponent={itemComponent}
                {...props}
            />
        ))}
    </div>
), {
    helperClass: 'sortable-helper',
    transitionDuration: 300
})

export const DragAndDropList = ({ items, setItems, itemComponent, ...props }) => {
    const onSortEnd = ({ oldIndex, newIndex }) => {
        const newItems = arrayMove(items, oldIndex, newIndex);
        setItems(newItems);
    };

    const list = useMemo(() => items.map((item, index) => ({ value: item, id: item.id || index })), [items]);

    return (
        <SortableList
            items={list}
            itemComponent={itemComponent}
            onSortEnd={onSortEnd}
            useDragHandle={true}
            helperClass={`sortable-helper`}
            {...props}
        />
    );
};

const IconStyled = styled(IconButton)`
  cursor: grab;
  &:active {
    cursor: grabbing;
  }
`

const DivStyled = styled.div`
    z-index: 1000;
    position: relative;
  visibility: visible !important;
  &:active {
    cursor: grabbing;
  }
    `


// WEBPACK FOOTER //
// ./src/components/common/DragAndDropList.js